export const HtmlContentSchema = (props) => {
  return {
    title: 'Custom Block',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['html'],
      },
    ],
    properties: {
      html: {
        title: 'HTML',
        type: 'string',
        widget: 'text',
      },
    },
    required: ['html'],
  };
};

export default HtmlContentSchema;
